import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  DriverBasicDetailsContainer,
  FieldHolder,
} from "../../../constants/assets/DriverDetailsContainers";
import variables from "../../../constants/assets/variables";
import DriverDocumentsDetailsFields from "../../../constants/DeliveryDrivers/DriverDocumentsDetailsFields.json";
import { connect } from "react-redux";
import { getPath } from "../../../utils";
import DirectUpload from "./DirectUpload";
import { bindActionCreators } from "redux";
import * as DeliveryDriversActions from "../../../store/actions/DeliveryDrivers";
import { setStatus } from "../../../store/actions/User";
import { useParams } from "react-router-dom";
import { validateDriverDocuments } from "./validations";
import ErrorModal from "../../Common/ErrorModal";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import commonStyles from "../../../static/styles/common";
import DriverDocumentModal from "../../Common/DriverDocumentModal";
import {
  FieldsContainer,
  FieldsSection,
} from "../../../constants/assets/containers";

const useStyles = makeStyles((_theme) => commonStyles.fileUploadButton);

export const requiredDocs = [
  "license_doc",
  "image",
  "registration_doc",
  "identity_proof_doc",
  "bank_doc",
  "current_address_proof_doc",
  "permanent_address_proof_doc",
  "pan_card_doc",
  "contract_doc",
  "ev_doc",
];

const DriverDocumentsDetail = ({
  documents,
  allMenuActions,
  editState,
  saveState,
  setSaveState,
  setStatus,
  updateDriverDocumentsDetails,
  handleAfterSave,
  getDriverDocuments,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [pdf, setPdf] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [uploadingFiles, setUploadingFiles] = useState({});
  const [triggerDirectUpload, setTriggerDirectUpload] = useState(false);
  const [formDisabled, setFormDisabled] = useState(false);
  const [errors, setErrors] = useState([]);

  const params = useParams();
  const classes = useStyles();

  const attachFile = (id, file) => {
    setUploadingFiles({
      ...uploadingFiles,
      [id]: { id: id, file: file },
    });
  };

  const shouldDirectUpload = (id) => {
    if (
      triggerDirectUpload &&
      uploadingFiles[id] &&
      !uploadingFiles[id].uploaded
    ) {
      return true;
    } else {
      return false;
    }
  };

  const directUploadFile = (id) => {
    return uploadingFiles[id].file;
  };

  const handleErrorModalSubmit = () => {
    setErrors([]);
  };

  const getField = (type, field) => {
    switch (type) {
      case "image": {
        var file_present = getPath(
          documents,
          `${field.key}.expiring_url`,
          false
        )
          ? true
          : false;
        return editState ? (
          <div>
            <React.Fragment>
              <Button
                variant="outlined"
                style={{ position: "relative" }}
                component="span"
                disabled={formDisabled}
                className={classes.uploadButton}
              >
                {`upload`}
                <input
                  type="file"
                  style={{ opacity: 0, position: "absolute" }}
                  id={field.id}
                  multiple
                  onChange={(e) =>
                    attachFile(field.id, e.currentTarget.files[0])
                  }
                />
              </Button>
              <p className={`${classes.fileName} mt-10`}>
                {getPath(uploadingFiles, `${field.id}.file.name`, false) ||
                  getPath(documents, `${field.key}.file_name`, false)}
              </p>
            </React.Fragment>

            {shouldDirectUpload(field.id) && (
              <DirectUpload
                driverId={params.id}
                type={field.id}
                directUploadFile={directUploadFile(field.id)}
                onUploadSuccess={(signed_id) => {
                  handleDirectUploadSuccess(field.id, signed_id);
                }}
                handleDirectUploadFailure={(error) =>
                  handleDirectUploadFailure(field.id, error)
                }
              />
            )}
          </div>
        ) : (
          <DocumentHolder>
            {file_present ? (
              <span
                onClick={() =>
                  handleDocClick(
                    documents[field.key].expiring_url,
                    documents[field.key].file_name
                  )
                }
                className="driverDoc"
              >
                {documents[field.key].file_name || "View"}
              </span>
            ) : (
              "-"
            )}
          </DocumentHolder>
        );
      }
      default:
        return "";
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setPdf("");
  };

  const handleDirectUploadSuccess = (id, signed_id) => {
    let oldFileData = uploadingFiles[id];
    setUploadingFiles({
      ...uploadingFiles,
      [id]: {
        id: id,
        file: oldFileData.file,
        document_type: id,
        uploaded: true,
        attachment: signed_id,
      },
    });
  };

  useEffect(() => {
    if (
      triggerDirectUpload === true &&
      formDisabled === true &&
      Object.keys(uploadingFiles).length !== 0
    ) {
      for (var key of Object.keys(uploadingFiles)) {
        if (uploadingFiles[key].uploaded !== true) {
          return;
        }
      }
      updateDriverDocumentsDetails(params.id, uploadingFiles)
        .then((_response) => {
          setSaveState(false);
          handleAfterSave();
          getDriverDocuments(params.id, { documents: requiredDocs });
        })
        .catch((_error) => {
          setSaveState(false);
        })
        .finally(() => {
          setTriggerDirectUpload(false);
          setFormDisabled(false);
        });
    }
  }, [uploadingFiles]);

  const handleDirectUploadFailure = (id, error) => {
    setStatus({
      type: "error",
      message: `${id} was not uploaded, error: ${error}. Please retry`,
    });
    // setUploadingFiles([]);
    setSaveState(false);
    setTriggerDirectUpload(false);
    setFormDisabled(false);
  };

  const handleSubmit = () => {
    setFormDisabled(true);
    let err = [];

    if (Object.keys(uploadingFiles).length === 0) {
      err.push("Error! You didn't make any change");
      setErrors(err);
    } else {
      err = validateDriverDocuments(uploadingFiles);
      setErrors(err);
    }
    if (err.length > 0) {
      setFormDisabled(false);
      setSaveState(false);
    } else {
      setTriggerDirectUpload(true);
    }
  };

  useEffect(() => {
    saveState && handleSubmit();
  }, [saveState]);

  useEffect(() => {
    setUploadingFiles({});
  }, [editState]);

  const handleDocClick = (url, fileName) => {
    setShowModal(true);
    if (fileName.includes("pdf")) {
      setPdf(url);
    } else {
      setModalContent(url);
    }
  };

  return [
    <DriverDocumentsDetailsContainer>
      <FieldsContainer>
        {DriverDocumentsDetailsFields.sections.map((section, index) => {
          return (
            <FieldsSection key={index}>
              {section.name && <p>{section.name}</p>}
              <FieldsContainer>
                {section.fields.map((field, fieldIdx) => {
                  return (
                    <FieldHolder
                      key={fieldIdx}
                      noBorder={field.noBorder}
                      justify="flex-start"
                    >
                      {field.placeholder && (
                        <span className="flex items-center flex-start">
                          {field.placeholder}
                          {field.isMandatory && <sup>*</sup>}
                        </span>
                      )}
                      {field.permissions
                        ? allMenuActions[field.permissions]
                          ? getField(field.type, field)
                          : ""
                        : getField(field.type, field)}
                    </FieldHolder>
                  );
                })}
              </FieldsContainer>
            </FieldsSection>
          );
        })}
      </FieldsContainer>
      {errors.length > 0 && (
        <ErrorModal
          handleSubmit={handleErrorModalSubmit}
          heading="Error while saving"
          errors={errors}
        />
      )}
    </DriverDocumentsDetailsContainer>,
    <DriverDocumentModal
      showModal={showModal}
      handleClose={handleClose}
      pdf={pdf}
      modalContent={modalContent}
    />,
  ];
};

const DriverDocumentsDetailsContainer = styled(DriverBasicDetailsContainer)`
  .document-info {
    font-size: 0.8rem;
    span {
      color: ${variables.blue500};
    }
  }
  a {
    text-align: right;
    display: block;
  }
`;

const DocumentHolder = styled.div`
  .driverDoc {
    color: ${variables.primaryColor};
    cursor: pointer;
    text-decoration: underline;
  }
`;

function mapStateToProps(state) {
  const { MenuActions } = state;

  return {
    allMenuActions: MenuActions.allMenuActions,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateDriverDocumentsDetails: bindActionCreators(
      DeliveryDriversActions.updateDriverDocuments,
      dispatch
    ),
    getDriverDocuments: bindActionCreators(
      DeliveryDriversActions.getDriverDocuments,
      dispatch
    ),
    setStatus: bindActionCreators(setStatus, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverDocumentsDetail);
